import PropTypes from "prop-types";
import { Box, Stack, Typography } from "@mui/material";
import { brandConfig } from "src/config/brand";

export const TenantSwitch = (props) => {
  return (
    <>
      <Stack
        alignItems="center"
        direction="row"
        spacing={2}
        {...props}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Typography
            color="inherit"
            variant="h6"
          >
            {brandConfig.name}
          </Typography>
        </Box>
      </Stack>
    </>
  );
};

TenantSwitch.propTypes = {
  sx: PropTypes.object,
};
